import React from "react"
import { AuthenticationComponent } from "../pages/Authentication.jsx"

export const ResetAccessTokenGuide = ({ onAccessTokenUpdated }) => {
	return (
		<div>
			<AuthenticationComponent
				newUser={false}
				forceCreateNewApp={true}
			/>
		</div>
	)
}
